import BaseController from './baseSystemController';
import eControllerTypes from './realityCheck/eControllerTypes';
import ControllerRealityCheckStartPopup from './realityCheck/ControllerStartPopup';
import { OP_WRAPPER_LOCALIZATION_PREFIX } from '../../../utils/constants';
import ControllerRealityCheckMainPopup from './realityCheck/ControllerMainPopup';
import Stopwatch from '../../../utils/Stopwatch';
import { getUrlParam } from '../../../utils/url';

export default class ControllerRealityCheck extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });

    this._eButtonsTypes = {
      EBT_CLOSE: 'close_button',
    };

    this._eEventTypes = {
      CLOSE_CLICK: this.getEventName(this._eButtonsTypes.EBT_CLOSE),
    };

    this._eControllersClasses = {
      [this.controllerTypes.ERCCT_START_POPUP]: ControllerRealityCheckStartPopup,
      [this.controllerTypes.ERCCT_MAIN_POPUP]: ControllerRealityCheckMainPopup,
    };

    this._eElementsTypes = {
      EET_OVERLAY: 'overlay',
      EET_MODAL_CONTAINER: 'modal_container',
      EET_TITLE: 'title',
      EET_CLOSE_BUTTON: this._eButtonsTypes.EBT_CLOSE,
      EET_START_POPUP_CONTAINER: this.controllerTypes.ERCCT_START_POPUP,
      EET_MAIN_POPUP_CONTAINER: this.controllerTypes.ERCCT_MAIN_POPUP,
    };

    this._eButtonsActions = {
      [this._eButtonsTypes.EBT_CLOSE]: this._continuePlay.bind(this),
    };

    this._localizations = {
      [this._eElementsTypes.EET_TITLE]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.realityCheck.title`,
    }
    this._minutesLocalization = `${OP_WRAPPER_LOCALIZATION_PREFIX}.realityCheck.minutes`;

    this._isSpinBlocker = true;

    this.defaultDecimals = 8;
    this._blockedGame = false;
    this._blockedRealityCheck = false;
    this.timeouts = [15, 30, 45, 60].map(value => ({ label: `${value} ${this._getLocalization(this._minutesLocalization)}`, value }));
    this.timeout = this.timeouts[0].value;
    this._isShownFirstTime = true;

    this._updateTimePlayed = this._updateTimePlayed.bind(this);
    this._onStatisticUpdate = this._onStatisticUpdate.bind(this);

    this.init(container);
    this.hide();
  }

  tryToShowOnStart(config) {
    if (!config.enableRealityCheck) return;
    this.show();
  }

  tryShow() {
    if (this._blockedGame && !this._blockedRealityCheck) this.show();
  }

  show() {
    super.show();
    if (this._isShownFirstTime) {
      this.controllers[this.controllerTypes.ERCCT_START_POPUP].show();
    } else {
      this.controllers[this.controllerTypes.ERCCT_MAIN_POPUP].show();
    }

    this._isShownFirstTime = false;
  }

  hide() {
    super.hide();
    this.controllers[this.controllerTypes.ERCCT_START_POPUP].hide();
    this.controllers[this.controllerTypes.ERCCT_MAIN_POPUP].hide();
  }

  _onStatisticUpdate({ totalWinAmount, totalBetAmount }) {
    this.controllers[this.controllerTypes.ERCCT_MAIN_POPUP].betAmount = this._round(totalBetAmount);
    this.controllers[this.controllerTypes.ERCCT_MAIN_POPUP].winAmount = this._round(totalWinAmount);
  }

  _afterInit() {
    super._afterInit();
    this._overlay = this.interactiveElements[this._eElementsTypes.EET_OVERLAY];
    this._modalContainer = this.interactiveElements[this._eElementsTypes.EET_MODAL_CONTAINER];
    // this._overlay.onclick = (e) => {
    //   if (e.target === this._overlay) {
    //     this.hide();
    //     this._continuePlay();
    //   }
    // };

    Stopwatch.onUpdateTime.add(this._updateTimePlayed);
    window.OPWrapperService.ControllerStatistic.onUpdate.add(this._onStatisticUpdate);

    this.controllers[this.controllerTypes.ERCCT_START_POPUP].timeoutOptions = this.timeouts;
    this.controllers[this.controllerTypes.ERCCT_START_POPUP].activeTimeout = this.timeouts[0].value;

    this.controllers[this.controllerTypes.ERCCT_MAIN_POPUP].timeoutOptions = this.timeouts;
    this.controllers[this.controllerTypes.ERCCT_MAIN_POPUP].activeTimeout = this.timeouts[0].value;
  }

  _addExtraControllersListeners() {
    super._addExtraControllersListeners();
    const startPopup = this.controllers[this.controllerTypes.ERCCT_START_POPUP];
    const mainPopup = this.controllers[this.controllerTypes.ERCCT_MAIN_POPUP];

    startPopup.on(startPopup.events[this.controllerTypes.ERCCT_START_POPUP].SUBMIT_CLICK, this._continuePlay.bind(this));
    mainPopup.on(mainPopup.events[this.controllerTypes.ERCCT_MAIN_POPUP].QUIT_CLICK, this._onExitClick.bind(this));
    mainPopup.on(mainPopup.events[this.controllerTypes.ERCCT_MAIN_POPUP].SUBMIT_CLICK, this._continuePlay.bind(this));

    startPopup.on(startPopup.events[this.controllerTypes.ERCCT_START_POPUP][startPopup.controllerTypes.EPCT_DROPDOWN].OPTION_CLICK, this._updateActiveTimeout.bind(this));
    mainPopup.on(mainPopup.events[this.controllerTypes.ERCCT_MAIN_POPUP][mainPopup.controllerTypes.EPCT_DROPDOWN].OPTION_CLICK, this._updateActiveTimeout.bind(this));
  }

  _updateActiveTimeout(value) {
    this.timeout = value;
    this.controllers[this.controllerTypes.ERCCT_START_POPUP].activeTimeout = value;
    this.controllers[this.controllerTypes.ERCCT_MAIN_POPUP].activeTimeout = value;
  }

  _continuePlay() {
    this.hide();
    this._blockedGame = false;
    this._timeoutId = setTimeout(()=> {
      this._blockedGame = true;
      this.tryShow();
    }, this.timeout * 60 * 1000)
  }

  _updateTimePlayed({ timeDifferenceText }) {
    this.controllers[this.controllerTypes.ERCCT_MAIN_POPUP].timePlayed = timeDifferenceText;
  }

  _updateLocalizations() {
    super._updateLocalizations();
    this.timeouts = this.timeouts.map(({ value }) => ({ label: `${value} ${this._getLocalization(this._minutesLocalization)}`, value }));
    this.controllers[this.controllerTypes.ERCCT_START_POPUP].timeoutOptions = this.timeouts;
    this.controllers[this.controllerTypes.ERCCT_MAIN_POPUP].timeoutOptions = this.timeouts;
  }

  _onExitClick() {
    window.OPWrapperService.initConfig.onButtonClick();
    const homeURL = getUrlParam('lobbyUrl');
    if (homeURL) {
      window.top.location.href = homeURL;
    } else if (window.history.length > 1) {
      window.history.back();
    } else {
      // this._showBlocker()
    }
  }

  _round(value) {
    return Math.round(value * 10 ** this.defaultDecimals) / 10 ** this.defaultDecimals;
  }

  beforeRemove() {
    super.beforeRemove();
    Stopwatch.onUpdateTime.remove(this._updateTimePlayed);
    window.OPWrapperService.ControllerStatistic.onUpdate.remove(this._onStatisticUpdate);
    clearTimeout(this._timeoutId);
  }

  get blockedGame() {
    return this._blockedGame;
  }

  set blockedRealityCheck(value) {
    this._blockedRealityCheck = value;
    if (!value) this.tryShow();
  }

  get blockedRealityCheck() {
    return this._blockedRealityCheck;
  }

  get controllerTypes() {
    return eControllerTypes;
  }

  set scaleData({ scaleData, rootScale }) {
    if (!this._mounted) return;
    this._scaleData = scaleData;

    this._modalContainer.dataset.orientation = scaleData.isPortrait ? 'portrait' : 'landscape';
    this._modalContainer.dataset.deviceType = scaleData.isMobile ? 'mobile' : 'desktop';

    for (const key in this.controllers) {
      const controller = this.controllers[key];
      controller.scaleData = { scaleData: this._scaleData };
    }
  }

  _getMarkup() {
    return `<div id=${this.interactiveElementsIds[this._eElementsTypes.EET_OVERLAY]} class="system-ui-container__modal_wrapper system-ui-container__modal__reality_check">
      <div id=${this.interactiveElementsIds[this._eElementsTypes.EET_MODAL_CONTAINER]} class="system-ui-container__modal_container system-ui-container__modal__reality_check__container">
        <div class="system-ui-container__modal_container__header">
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TITLE]}>
                  ${this._getLocalization(this._localizations[this._eElementsTypes.EET_TITLE])}
          </span>
          <button id=${this.interactiveElementsIds[this._eElementsTypes.EET_CLOSE_BUTTON]} class="system-ui-container__close_button system-ui-container__modal_container__header__close">
            <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M66 22L22 66M22 22L66 66" stroke="white" stroke-width="6.28571" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        
        <div class="system-ui-container__modal__reality_check__container__body">
          <div id=${this.interactiveElementsIds[this._eElementsTypes.EET_START_POPUP_CONTAINER]}></div>
          <div id=${this.interactiveElementsIds[this._eElementsTypes.EET_MAIN_POPUP_CONTAINER]}></div>
        </div>
      </div>
      
    </div>`
  }
}
